import React, { PureComponent, Fragment } from 'react'
import { Button, Sidebar } from '../../../../components'

import ContactSidebarFilter from './filter/filter.component'
import { THEMES } from '../../../../utils/ui'

/**
 * Sidebar Header
 * @param props
 * @return {*}
 * @constructor
 */
const Header = (props) => {
  const { onFilterReset } = props

  return (
    <Fragment>
      <div className='sidebar_header-title'>Contact Filters</div>
      <Button
        theme={THEMES.SOFT_GREY}
        label='Reset'
        onClick={onFilterReset} />
    </Fragment>
  )
}

/**
 * Contact Sidebar Component
 */
class ContactSidebar extends PureComponent {
  /**
   * Render
   * @return {XML}
   */
  render () {
    const { filters, isSidebarCollapsed, onFilterChange, onFilterReset } = this.props
    return (
      <Sidebar
        collapsed={isSidebarCollapsed}
        headerTemplate={<Header onFilterReset={onFilterReset} />}>
        <ContactSidebarFilter
          filters={filters}
          onFilterChange={onFilterChange} />
      </Sidebar>
    )
  }
}

export default ContactSidebar
